<template>
  <div class="container">
    <div class="info" v-if="shop.id">
      <el-descriptions title="店铺信息" :column="2" border>
        <el-descriptions-item label="店铺logo">
          <el-image
            v-if="shop.shop_logo"
            style="width: 100px; height: 100px"
            :src="shop.shop_logo"
            :preview-src-list="[shop.shop_logo]"
          ></el-image>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="店铺编号">{{
          shop.shop_no
        }}</el-descriptions-item>
        <el-descriptions-item label="店铺名称">{{
          shop.shop_name
        }}</el-descriptions-item>
        <el-descriptions-item label="所属合作商">{{
          shop.map ? shop.map.coop_name : ""
        }}</el-descriptions-item>
        <el-descriptions-item label="行业">{{
          shop.industry
        }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{
          shop.contact_phone
        }}</el-descriptions-item>
        <el-descriptions-item label="营业时间">{{
          shop.business_hours
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="small" type="info" v-if="shop.status === 0"
            >待审核</el-tag
          >
          <el-tag size="small" type="success" v-if="shop.status === 1"
            >营业中</el-tag
          >
          <el-tag size="small" type="warning" v-if="shop.status === 2"
            >已关闭</el-tag
          >
          <el-tag size="small" type="danger" v-if="shop.status === 3"
            >已禁用</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="排序">{{
          shop.sort
        }}</el-descriptions-item>
        <el-descriptions-item label="所在地区">{{
          shop.province + shop.city + shop.district
        }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{
          shop.address
        }}</el-descriptions-item>
        <el-descriptions-item label="经度">{{
          shop.longitude
        }}</el-descriptions-item>
        <el-descriptions-item label="纬度">{{
          shop.latitude
        }}</el-descriptions-item>
        <el-descriptions-item label="店铺说明" :span="2">{{
          shop.shop_desc
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          shop.create_time
        }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{
          shop.update_time
        }}</el-descriptions-item>
      </el-descriptions>
      <div class="handle">
        <el-button size="small" type="success" @click="update">编辑</el-button>
      </div>
    </div>
    <div class="info" v-if="account.shop_id">
      <el-descriptions title="店铺账户" :column="2" border>
        <el-descriptions-item label="可用余额(元)">{{
          account.available_balance
        }}</el-descriptions-item>
        <el-descriptions-item label="押金冻结(元)">{{
          account.deposit_frozen
        }}</el-descriptions-item>
        <el-descriptions-item label="累计入账(元)">{{
          account.total_income
        }}</el-descriptions-item>
        <el-descriptions-item label="累计支出(元)">{{
          account.total_expend
        }}</el-descriptions-item>
        <el-descriptions-item label="年费到期日">{{
          account.annual_fee_due_at || "未缴/免缴"
        }}</el-descriptions-item>
        <el-descriptions-item label="账户状态">
          <el-tag size="small" type="success" v-if="account.status === 1"
            >正常</el-tag
          >
          <el-tag size="small" type="danger" v-if="account.status === 2"
            >欠费</el-tag
          >
          <el-tag size="small" type="info" v-if="account.status === 3"
            >关闭</el-tag
          >
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="info" v-if="feeRule.id || feeRule.source">
      <el-descriptions title="生效收费规则" :column="2" border>
        <el-descriptions-item label="规则来源">
          <el-tag size="small" v-if="feeRule.source === 'PLATFORM'"
            >平台默认</el-tag
          >
          <el-tag
            size="small"
            type="warning"
            v-else-if="feeRule.source === 'COOP'"
            >合作商覆盖</el-tag
          >
          <el-tag size="small" type="info" v-else>未配置规则</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="规则ID">{{
          feeRule.id || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="年费(元/年)">{{
          feeRule.annual_fee
        }}</el-descriptions-item>
        <el-descriptions-item label="押金(元)">{{
          feeRule.deposit
        }}</el-descriptions-item>
        <el-descriptions-item label="订单服务费率">{{
          feeRule.order_fee_rate
            ? (feeRule.order_fee_rate * 100).toFixed(2) + "%"
            : "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="单笔最低服务费">{{
          feeRule.order_min_fee || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="生效时间">{{
          feeRule.effective_at || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="失效时间">{{
          feeRule.expire_at || "长期有效"
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <AddorEdit @success="getDetails" ref="AddorEdit"></AddorEdit>
  </div>
</template>

<script>
import AddorEdit from "./components/AddorEdit.vue";

export default {
  components: {
    AddorEdit,
  },
  data() {
    return {
      id: "",
      shop: {},
      account: {},
      feeRule: {},
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDetails();
      }
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
  },

  methods: {
    update() {
      this.$refs.AddorEdit.open(this.shop);
    },
    getDetails() {
      this.$axios({
        url: "/user/shop/findById",
        params: {
          id: this.id,
        },
      }).then((res) => {
        this.shop = res.data.data;
      });
      this.getAccount();
      this.getFeeRule();
    },
    getAccount() {
      this.$axios({
        url: "/user/shopAccount/info",
        params: {
          shop_id: this.id,
        },
      }).then((res) => {
        this.account = res.data.data || {};
      });
    },
    getFeeRule() {
      this.$axios({
        url: "/user/shopFeeRule/effective",
        params: {
          shop_id: this.id,
        },
      }).then((res) => {
        this.feeRule = res.data.data || {};
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  margin-bottom: 30px;
}
.handle {
  margin-top: 15px;
}
</style>
